import { makeStyles } from "@mui/styles"

export const useStyles = makeStyles(() => ({
  container: {
    padding: "30px",
  },
  dashboardHeaderContainer: {
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    fontSize: "30px !important",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#00182F",
    marginBottom: "20px",
  },
  dashboardHeaderTitle: {
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    fontSize: "25px !important",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#363636",
  },
  dashboardHeaderSubTitle: {
    fontFamily: "Ubuntu !important",
    fontSize: "12px !important",
    fontWeight: "400 !important",
    lineHeight: "28px",
    letterSpacing: "0.15px",
    color: "#363636",
  },
  countMessageContainer: {
    width: "32% !important",
    height: "100%"
  },
  countMessageItemContainer: {
    width: "45% !important",
  },
  countMessageItem: {
    borderRadius: "30px",
    fontSize: "30px",
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    boxShadow: "0px 4px 4px 0px #00000010",
    width: "100%",
    textAlign: "center",
    padding: "15px",
    border: "1px solid rgba(0, 0, 0,0)",
    marginBottom: "8px !important",
  },
  countMessageItemText: {
    width: "100%",
    fontSize: "12px",
    color: "black",
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    textAlign: "center !important",
  },
  graphicLinearContainer: {
    boxShadow: "0px 4px 4px 0px #00000010",
    width: "67%",
    minHeight: "400px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "start",
    padding: "15px",
  },
  graphicLinearContainerDark: {
    boxShadow: "0px 4px 4px 0px #00000010",
    width: "67%",
    minHeight: "400px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    padding: "15px",
    background: "#000000DE !important",
    color: "white !important",
    border: "1px solid white",
  },
  messageByProductContainer: {
    width: "100%",
    borderRadius: "10px",
    position: "relative",
    marginTop: "40px !important",
    padding: "0px",
    boxSizing: "border-box",
    height: "100%",
  },
  progressBar: {
    background: "white !important",
    height: "15px  !important",
    border: "1px solid #32A4D4",
    borderRadius: "40px",
    "&.MuiLinearProgress-root .MuiLinearProgress-bar": {
      backgroundColor: " #1BC3DD !important",
      borderRadius: "40px",
    },
  },
  totalSmsContainer: {
    padding: "15px",
    borderRadius: "10px",
    marginBottom: "10px",
  },
  carrierGraphicContainer: {
    padding: "15px",
    borderRadius: "10px",
  },
  secondSectionContainer: {
    marginTop: "15px !important",
  },
  liStyle: {
    background: "red",
    "& :active": {
      background: "blue",
    },
  },
  legendMenu: {
    position: "absolute",
    transform: "translateX(-120px) translateY(30px)",
    width: "150px",
    height: "auto",
    maxHeight: "140px",
    padding: "12px 18px",
    boxShadow: "0px 4px 4px 0px #00000040",
    background: "white",
    borderRadius: "20px",
    overflowY: "auto",
    zIndex: 100,
  },
  select: {
    height: "30px",
    borderRadius: "5px",
    backgroundColor: "white",
    color: "black",
    "& .MuiInputBase-input": {
      height: "30px",
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "24px",
      fontFamily: "Ubuntu !important",
    },
    "& .MuiInputLabel-root": {
      color: "rgba(0, 0, 0, 0.87)",
    },
    "& .MuiSvgIcon-root": {
      color: "#4E5589",
      fontSize: "30px",

      borderLeft: "1px solid #C4C4C4",

      borderRadius: "1",
      borderColor: "transparent",
    },
    "& .MuiFormHelperText-contained": {
      margin: 0,
      paddingLeft: "10px",
      paddingTop: "5px",
    },
  },
}))

export const useStylesDark = makeStyles(() => ({
  container: {
    padding: "30px",
    background: "#131313 !important",
  },
  dashboardHeaderContainer: {
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    fontSize: "30px !important",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "white !important",
    marginBottom: "18px",
  },
  dashboardHeaderTitle: {
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    fontSize: "25px !important",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "white !important",
  },
  dashboardHeaderSubTitle: {
    fontFamily: "Ubuntu !important",
    fontSize: "12px !important",
    fontWeight: "400 !important",
    lineHeight: "28px",
    letterSpacing: "0.15px",
    color: "white !important",
  },
  countMessageContainer: {
    width: "32% !important",
    height: "100%"
  },
  countMessageItemContainer: {
    width: "45% !important",
  },
  countMessageItem: {
    borderRadius: "30px",
    fontSize: "30px",
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    boxShadow: "0px 4px 4px 0px #00000010",
    width: "100%",
    textAlign: "center",
    padding: "15px",
    color: "white",
    border: "1px solid white",
    marginBottom: "8px !important",
  },
  countMessageItemText: {
    width: "100%",
    fontSize: "12px",
    color: "white",
    fontFamily: "Ubuntu !important",
    fontStyle: "normal !important",
    fontWeight: "700 !important",
    textAlign: "center !important",
  },
  graphicLinearContainer: {
    boxShadow: "0px 4px 4px 0px #00000010",
    width: "67%",
    minHeight: "400px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    padding: "15px",
    /*   background:'#000000DE', */
    color: "white !important",
    border: "1px solid white",
  },
  messageByProductContainer: {
    width: "100%",
    height: "100%",
    borderRadius: "10px",
    position: "relative",
    marginTop: "40px !important",
    boxSizing: "border-box",
    padding: "0px",
  },
  progressBar: {
    background: "black !important",
    height: "15px  !important",
    border: "1px solid #32A4D4",
    borderRadius: "40px",
    "&.MuiLinearProgress-root .MuiLinearProgress-bar": {
      backgroundColor: "#1BC3DD !important",
      borderRadius: "40px",
    },
  },
  totalSmsContainer: {
    padding: "10px",
    boxShadow: "0px 4px 4px 0px #0000001F",
    border: "1px solid white",
    borderRadius: "10px",
    marginBottom: "10px",
  },
  carrierGraphicContainer: {
    padding: "15px",
    boxShadow: "0px 4px 4px 0px #0000001F",
    borderRadius: "10px",
    border: "1px solid rgba(255, 255, 255, 0.50)",
  },
  secondSectionContainer: {
    marginTop: "15px !important",
    borderRadius: "10px",

    border: "1px solid white",
    color: "white !important",
  },
  legendMenu: {
    position: "absolute",
    transform: "translateX(-120px) translateY(30px)",
    width: "150px",
    height: "auto",
    maxHeight: "140px",
    padding: "12px 18px",
    boxShadow: "0px 4px 4px 0px #00000040",
    background: "black",
    borderRadius: "20px",
    overflowY: "auto",
    zIndex: 100,
  },
  select: {
    height: "30px",
    borderRadius: "5px",
    border: "1px solid white",
    backgroundColor: "#212121 !important",
    color: "white",
    "& .MuiInputBase-input": {
      height: "30px",
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "24px",
      fontFamily: "Ubuntu !important",
      color: "white",
    },
    "& .MuiInputLabel-root": {
      color: "white",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      fontSize: "30px",

      borderLeft: "1px solid #C4C4C4",

      borderRadius: "1",
      borderColor: "transparent",
    },
    "& .MuiFormHelperText-contained": {
      margin: 0,
      paddingLeft: "10px",
      paddingTop: "5px",
    },
  },
}))
